export const InvitationAction = Object.freeze({
  ACCEPT: 'accepted',
  REJECT: 'rejected',
});

export const InvitationStatus = Object.freeze({
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  REVOKED: 'revoked',
});
